import { Vault } from "../../libs/storage.js";

export {
  FunnelParams,
  CUSTOM_PARAM,
  CUSTOM_STORAGE_KEY,
  FORCE_PREFIX,
  FORCE_CLEAR_PARAM,
  FORCE_STORAGE_KEY,
};

// Dos parámetros de URL del funnel-router (api-content) que hasta ahora solo valían en la
// página cuya URL los llevaba. Se persisten para que sigan aplicando en el resto del funnel;
// la URL se deja como está (TTH-1557).
//   - ?proto_c=<valor>: dimensión "custom" del targeting. 365 días, como las UTMs; solo lo
//     sustituye otro proto_c en la URL.
//   - ?__pfr_force_<stepId>=<childStepId>: fuerza la rama de un nodo de decisión (QA). 1 día:
//     vale en cualquier pestaña pero no deja al tester pegado a esa rama un año.
//     ?__pfr_force_clear=1 vacía los forzados guardados.
// El funnel-router lee las dos claves (URL primero, luego storage): si cambias un nombre o el
// formato, actualiza funnelRouterScript.ts en api-content.
const CUSTOM_PARAM = "proto_c";
const CUSTOM_STORAGE_KEY = "f_custom";
const CUSTOM_TTL = "365d";
const FORCE_PREFIX = "__pfr_force_";
const FORCE_CLEAR_PARAM = "__pfr_force_clear";
const FORCE_STORAGE_KEY = "f_forced";
const FORCE_TTL = "1d";

type ForcedChoices = Record<string, number>;

class FunnelParams {
  private _custom: string | null = null;
  private _forced: ForcedChoices = {};

  constructor() {
    const params = new URLSearchParams(window.location.search);

    this._custom = this._readCustom(params);
    this._forced = this._readForced(params);

    this._save();
  }

  get custom(): string | null {
    return this._custom;
  }

  get forced(): ForcedChoices {
    return { ...this._forced };
  }

  // URL primero; sin parámetro, lo guardado.
  private _readCustom(params: URLSearchParams): string | null {
    const fromUrl = params.get(CUSTOM_PARAM);
    if (fromUrl !== null && fromUrl !== "") return fromUrl;

    const stored = Vault.get(CUSTOM_STORAGE_KEY);
    return typeof stored === "string" && stored !== "" ? stored : null;
  }

  // Los forzados de la URL se SUMAN a los guardados (uno por nodo); `clear` vacía antes.
  private _readForced(params: URLSearchParams): ForcedChoices {
    const forced: ForcedChoices =
      params.get(FORCE_CLEAR_PARAM) !== null ? {} : this._storedForced();

    params.forEach((value, name) => {
      if (name.indexOf(FORCE_PREFIX) !== 0) return;
      const stepId = parseInt(name.slice(FORCE_PREFIX.length), 10);
      const childStepId = parseInt(value, 10);
      if (!isNaN(stepId) && !isNaN(childStepId))
        forced[String(stepId)] = childStepId;
    });

    return forced;
  }

  private _storedForced(): ForcedChoices {
    const stored: unknown = Vault.get(FORCE_STORAGE_KEY);
    return stored && typeof stored === "object"
      ? (stored as ForcedChoices)
      : {};
  }

  private _save(): void {
    if (this._custom !== null) {
      Vault.set(CUSTOM_STORAGE_KEY, this._custom, { expires: CUSTOM_TTL });
    }

    if (Object.keys(this._forced).length === 0) {
      Vault.remove(FORCE_STORAGE_KEY);
    } else {
      Vault.set(FORCE_STORAGE_KEY, this._forced, { expires: FORCE_TTL });
    }
  }
}
